import NaptimeResource from './NaptimeResource';

class OnDemandDiscussionPromptQuestions extends NaptimeResource {
  static RESOURCE_NAME = 'onDemandDiscussionPromptQuestions.v1';

  static DEFAULT_FIELDS = [
    'content',
    'creatorId',
    'createdAt',
    'forumId',
    'sessionId',
    'lastAnsweredBy',
    'lastAnsweredAt',
    'totalAnswerCount',
    'topLevelAnswerCount',
    'viewCount',
  ];
}

export default OnDemandDiscussionPromptQuestions;
